import {
  GET_USER_FETCH,
  GET_USER_SUCCESS,
  GET_USER_REJECTED,
  GET_USERS_FETCH,
  GET_USERS_SUCCESS,
  GET_USERS_REJECTED,
  GET_APPROVER_FETCH,
  GET_APPROVER_SUCCESS,
  GET_APPROVER_REJECTED,
  GET_APPROVERS_FETCH,
  GET_APPROVERS_SUCCESS,
  GET_APPROVERS_REJECTED,
  SAVE_USER_SUCCESS,
  SAVE_USER_REJECTED,
  GET_ROLES_FETCH,
  GET_ROLES_SUCCESS,
  GET_ROLES_REJECTED,
  GET_ROLE_FETCH,
  GET_ROLE_SUCCESS,
  GET_ROLE_REJECTED,
  SAVE_ROLE_SUCCESS,
  SAVE_ROLE_REJECTED,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_REJECTED,
  GET_PERMISSIONS_FETCH,
  GET_PERMISSIONS_SUCCESS,
  GET_PERMISSIONS_REJECTED,
  GET_PERMISSION_FETCH,
  GET_PERMISSION_SUCCESS,
  GET_PERMISSION_REJECTED,
  SAVE_PERMISSION_SUCCESS,
  SAVE_PERMISSION_REJECTED,
  DELETE_PERMISSION_SUCCESS,
  DELETE_PERMISSION_REJECTED,
  SAVE_ROLE_PERMISSION_SUCCESS,
  SAVE_ROLE_PERMISSION_REJECTED,
  GET_DOA_ROLES_FETCH,
  GET_DOA_ROLES_SUCCESS,
  GET_DOA_ROLES_REJECTED,
  GET_ROLE_USER_FETCH,
  GET_ROLE_USER_SUCCESS,
  GET_ROLE_USER_REJECTED,
  GET_DOA_ROLE_USER_FETCH,
  GET_DOA_ROLE_USER_SUCCESS,
  GET_DOA_ROLE_USER_REJECTED,
  LIST_USER_MANAGER_FETCH,
  LIST_USER_MANAGER_SUCCESS,
  LIST_USER_MANAGER_REJECTED,
  GET_CEOS_FETCH,
  GET_CEOS_SUCCESS,
  GET_CEOS_REJECTED,
} from "./../../Constants";

const initialState = {
  users: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  userRolePR: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  userRoleDOA: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  approvers: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  ceos: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  approver: {
    data: null,
    isLoading: false,
    isRejected: false,
  },
  userSave: {
    message: null,
    isLoading: false,
    isRejected: false,
  },
  user: {
    data: null,
    isLoading: false,
    isRejected: false,
  },
  roles: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  doaRoles: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  roleSave: {
    message: null,
    isLoading: false,
    isRejected: false,
  },
  roleDelete: {
    message: null,
    isLoading: false,
    isRejected: false,
  },
  role: {
    data: null,
    isLoading: false,
    isRejected: false,
  },
  permissions: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  permissionSave: {
    message: null,
    isLoading: false,
    isRejected: false,
  },
  permissionDelete: {
    message: null,
    isLoading: false,
    isRejected: false,
  },
  permission: {
    data: null,
    isLoading: false,
    isRejected: false,
  },
  rolePermissionSave: {
    message: null,
    isLoading: false,
    isRejected: false,
  },
  userDepartments: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  userManagers: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SAVE_ROLE_PERMISSION_SUCCESS:
      return {
        ...state,
        rolePermissionSave: { message: payload, isRejected: false },
      };
    case SAVE_ROLE_PERMISSION_REJECTED:
      return {
        ...state,
        rolePermissionSave: { message: payload, isRejected: true },
      };
    case "GET_USER_DEPARTMENT_FETCH":
      return {
        ...state,
        userDepartments: { isLoading: true, isRejected: false },
      };
    case "GET_USER_DEPARTMENT_SUCCESS":
      return {
        ...state,
        userDepartments: { data: payload, isLoading: false, isRejected: false },
      };
    case "GET_USER_DEPARTMENT_REJECTED":
      return {
        ...state,
        userDepartments: { isLoading: false, isRejected: true },
      };
    case GET_APPROVER_FETCH:
      return {
        ...state,
        approver: { isLoading: true, isRejected: false },
      };
    case GET_APPROVER_SUCCESS:
      return {
        ...state,
        approver: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_APPROVER_REJECTED:
      return {
        ...state,
        approver: { isLoading: false, isRejected: true },
      };
    case GET_APPROVERS_FETCH:
      return {
        ...state,
        approvers: { isLoading: true, isRejected: false },
      };
    case GET_APPROVERS_SUCCESS:
      return {
        ...state,
        approvers: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_APPROVERS_REJECTED:
      return {
        ...state,
        approvers: { isLoading: false, isRejected: true },
      };

    case GET_CEOS_FETCH:
      return {
        ...state,
        ceos: { isLoading: true, isRejected: false },
      };
    case GET_CEOS_SUCCESS:
      return {
        ...state,
        ceos: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_CEOS_REJECTED:
      return {
        ...state,
        ceos: { isLoading: false, isRejected: true },
      };

    case GET_USERS_FETCH:
      return {
        ...state,
        users: { isLoading: true, isRejected: false },
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_USERS_REJECTED:
      return {
        ...state,
        users: { isLoading: false, isRejected: true },
      };

    case GET_USER_FETCH:
      return {
        ...state,
        user: { isLoading: true, isRejected: false },
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        user: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_USER_REJECTED:
      return {
        ...state,
        user: { isLoading: false, isRejected: true },
      };

    case SAVE_USER_SUCCESS:
      return {
        ...state,
        userSave: { message: payload, isRejected: false },
      };
    case SAVE_USER_REJECTED:
      return {
        ...state,
        userSave: { message: payload, isRejected: true },
      };

    case GET_ROLES_FETCH:
      return {
        ...state,
        roles: { isLoading: true, isRejected: false },
      };
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_ROLES_REJECTED:
      return {
        ...state,
        roles: { isLoading: false, isRejected: true },
      };

    case GET_ROLE_FETCH:
      return {
        ...state,
        role: { isLoading: true, isRejected: false },
      };
    case GET_ROLE_SUCCESS:
      return {
        ...state,
        role: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_ROLE_REJECTED:
      return {
        ...state,
        role: { isLoading: false, isRejected: true },
      };
    case GET_DOA_ROLES_FETCH:
      return {
        ...state,
        doaRoles: { data: [], isLoading: true, isRejected: false },
      };
    case GET_DOA_ROLES_SUCCESS:
      return {
        ...state,
        doaRoles: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_DOA_ROLES_REJECTED:
      return {
        ...state,
        doaRoles: { data: [], isLoading: false, isRejected: true },
      };

    case SAVE_ROLE_SUCCESS:
      return {
        ...state,
        roleSave: { message: payload, isRejected: false },
      };
    case SAVE_ROLE_REJECTED:
      return {
        ...state,
        roleSave: { message: payload, isRejected: true },
      };

    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        roleDelete: { message: payload, isRejected: false },
      };

    case DELETE_ROLE_REJECTED:
      return {
        ...state,
        roleDelete: { message: payload, isRejected: true },
      };

    case GET_PERMISSIONS_FETCH:
      return {
        ...state,
        permissions: { isLoading: true, isRejected: false },
      };
    case GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_PERMISSIONS_REJECTED:
      return {
        ...state,
        permissions: { isLoading: false, isRejected: true },
      };

    case GET_PERMISSION_FETCH:
      return {
        ...state,
        permission: { isLoading: true, isRejected: false },
      };
    case GET_PERMISSION_SUCCESS:
      return {
        ...state,
        permission: { data: payload, isLoading: false, isRejected: false },
      };
    case GET_PERMISSION_REJECTED:
      return {
        ...state,
        permission: { isLoading: false, isRejected: true },
      };

    case SAVE_PERMISSION_SUCCESS:
      return {
        ...state,
        permissionSave: { message: payload, isRejected: false },
      };
    case SAVE_PERMISSION_REJECTED:
      return {
        ...state,
        permissionSave: { message: payload, isRejected: true },
      };

    case DELETE_PERMISSION_SUCCESS:
      return {
        ...state,
        permissionDelete: { message: payload, isRejected: false },
      };

    case DELETE_PERMISSION_REJECTED:
      return {
        ...state,
        permissionDelete: { message: payload, isRejected: true },
      };

    case GET_ROLE_USER_FETCH:
      return {
        ...state,
        userRolePR: {
          data: [],
          isLoading: true,
          isRejected: false,
        },
      };
    case GET_ROLE_USER_SUCCESS:
      return {
        ...state,
        userRolePR: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_ROLE_USER_REJECTED:
      return {
        ...state,
        userRolePR: {
          data: [],
          isLoading: false,
          isRejected: true,
        },
      };
    case GET_DOA_ROLE_USER_FETCH:
      return {
        ...state,
        userRoleDOA: {
          data: [],
          isLoading: true,
          isRejected: false,
        },
      };
    case GET_DOA_ROLE_USER_SUCCESS:
      return {
        ...state,
        userRoleDOA: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_DOA_ROLE_USER_REJECTED:
      return {
        ...state,
        userRoleDOA: {
          data: [],
          isLoading: false,
          isRejected: true,
        },
      };

    case LIST_USER_MANAGER_FETCH:
      return {
        ...state,
        userManagers: {
          data: [],
          isLoading: true,
          isRejected: false,
        },
      };
    case LIST_USER_MANAGER_SUCCESS:
      return {
        ...state,
        userManagers: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case LIST_USER_MANAGER_REJECTED:
      return {
        ...state,
        userManagers: {
          data: [],
          isLoading: false,
          isRejected: true,
        },
      };

    default:
      return state;
  }
};
